import { useState, useEffect, useContext } from "react";
import { AuthContext, AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";
import styles from "./ReservationTable.module.css";
import { productData } from "../Constant/ConstantRegister";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { PushReservation } from "../../component/Calendar";
import { ReservationType } from "./Reservation";

export default function ReservationTable() {
  const navigate = useNavigate();
  const [selectManufacture, setSelectManufacture] = useState<string[]>([]);
  const [selectedManufacture, setSelectedManufacture] = useState<string>("");
  const [products, setProducts] = useState<productData[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<string>("");
  const [selectLR, setSelectLR] = useState<string[]>([]);
  const [selectSize, setSelectSize] = useState<string[]>([]);
  const [selectColor, setSelectColor] = useState<string[]>([]);
  const [selectedLR, setSelectedLR] = useState<string>("");
  const [selectedSize, setSelectedSize] = useState<string>("");
  const [selectedColor, setSelectedColor] = useState<string>("");
  const [inputedQuantity, setInputedQuantity] = useState<string>("1");
  const [schedule, setSchedule] = useState<ReservationType[]>([]);
  const { auth, setAuth } = useContext(AuthContext) as AuthContextType;
  const [reload, setReload] = useState<boolean>(false);
  const [selectedOffice, setSelectedOffice] = useState<string>(
    auth.office || ""
  );
  const [selectUser, setSelectUser] = useState<string[]>([]);
  const [selectedUser, setSelectedUser] = useState<string>(auth.username || "");
  const [toggleDate, setToggleDate] = useState<boolean>(false);
  const [inputedDate, setInputedDate] = useState<string>("");
  const [selectedOffice2, setSelectedOffice2] = useState<string>(
    auth.office || ""
  );

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${baseUrl}/checkAuth`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (!data.result) {
          console.log("Not authenticated");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        const response2 = await fetch(`${baseUrl}/getusersdata`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: data.username }),
        });
        const data2 = await response2.json();
        console.log(
          "Authenticated user:",
          data.username,
          "Office:",
          data2.office,
          "Authority:",
          data2.authority
        );
        setAuth({
          username: data.username,
          isAuthenticated: true,
          office: data2.office,
          authority: data2.authority,
        });
      } catch (error) {
        console.error(error);
      }
    };
    checkAuth();
  }, [navigate, setAuth]);

  useEffect(() => {
    const fetchSelectInit = async () => {
      const response = await fetch(`${baseUrl}/getmanufacture`, {
        method: "GET",
        credentials: "include",
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      const Manufactures = data.manufacture.map((item: Object) =>
        Object.values(item)
      );
      setSelectManufacture(Manufactures);
    };

    fetchSelectInit();
  }, []);

  useEffect(() => {
    const fetchSelectUser = async () => {
      const response = await fetch(`${baseUrl}/getUser`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ office: selectedOffice }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      const users = data.map((item: Object) => Object.values(item));
      setSelectUser(users);
      setSelectedUser(users[0] || "");
    };
    fetchSelectUser();
  }, [selectedOffice]);

  useEffect(() => {
    const fetchProduct = async () => {
      const response = await fetch(`${baseUrl}/getproducts`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          manufacture: selectedManufacture,
        }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      setProducts(data);
    };
    fetchProduct();
  }, [selectedManufacture, navigate, setAuth]);

  useEffect(() => {
    const fetchProductdata = async () => {
      if (selectedProduct === "") {
        setSelectLR([]);
        setSelectSize([]);
        setSelectColor([]);
        return;
      }
      const selectedProductData = products.find(
        (item) => item.productname === selectedProduct
      );
      const product_id = selectedProductData?.product_id;
      const response = await fetch(`${baseUrl}/productdata`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ product_id: product_id }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        return;
      }
      setSelectLR(data.leftright);
      setSelectSize(data.size);
      setSelectColor(data.color);
      if (data.leftright.length > 0) {
        setSelectedLR(data.leftright[0]);
      }
      if (data.size.length > 0) {
        setSelectedSize(data.size[0]);
      }
      if (data.color.length > 0) {
        setSelectedColor(data.color[0]);
      }
    };
    fetchProductdata();
  }, [selectedProduct, products, navigate, setAuth]);

  useEffect(() => {
    const fecthSchedule = async () => {
      const response = await fetch(`${baseUrl}/getreservation`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ office: selectedOffice2 }),
      });
      const data = await response.json();
      console.log(data);
      if (data.isAuth === false) {
        alert("セッションが切れました。再度ログインしてください");
        setAuth({
          username: null,
          isAuthenticated: false,
          office: undefined,
          authority: "user",
        });
        return navigate("/login");
      }
      for (let i = 0; i < data.length; i++) {
        const order_at = new Date(data[i].order_at);
        const dayofweek = [
          "（日）",
          "（月）",
          "（火）",
          "（水）",
          "（木）",
          "（金）",
          "（土）",
        ];
        const convert = (dateItem: Date) => {
          const japanOffset = 9 * 60 * 60 * 1000;
          const japanDate = new Date(dateItem.getTime() + japanOffset);
          const year = japanDate.getFullYear();
          const month = japanDate.getMonth() + 1;
          const date = japanDate.getDate();
          const day = dayofweek[japanDate.getDay()];
          const hours = japanDate.getHours();
          const minutes = japanDate.getMinutes();
          const seconds = japanDate.getSeconds();
          const convertDate = {
            date: `${year}年${month}月${date}日${day}`,
            time: `${hours}: ${minutes}: ${seconds}`,
          };
          return convertDate;
        };
        const convertdata = convert(order_at);
        data[i].order_at = convertdata.date;
      }
      let newData = [...data];
      for (let i = 0; i < data.length; i++) {
        let reservationDate = new Date(data[i].reservation_date);
        reservationDate.setHours(reservationDate.getHours() + 9);
        if (!data[i].reservation_date) {
          newData[i].reservation_date = "";
        } else {
          newData[i].reservation_date = {
            year: reservationDate.getFullYear(),
            month: reservationDate.getMonth() + 1,
            date: reservationDate.getDate(),
          };
        }
        let receiveDate = new Date(data[i].receiveDate);
        receiveDate.setHours(receiveDate.getHours() + 9);
        if (!data[i].receiveDate) {
          newData[i].receiveDate = "";
        } else {
          newData[i].receiveDate = `${receiveDate.getFullYear()}年${
            receiveDate.getMonth() + 1
          }月${receiveDate.getDate()}日`;
        }
      }
      setSchedule(newData);
      console.log(newData);
    };
    fecthSchedule();
  }, [reload, selectedOffice2, navigate, setAuth]);

  const handleManufacture = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedManufacture(e.target.value);
  };

  const handleProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedProduct(e.target.value);
  };

  const handleLR = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedLR(e.target.value);
  };

  const handleSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedSize(e.target.value);
  };
  const handleColor = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedColor(e.target.value);
  };

  const handleQuantity = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputedQuantity(e.target.value);
  };

  const pushReservation = async () => {
    if (!auth.username) {
      alert("ログイン情報がありません。再度ログインしてください");
      setAuth({
        username: null,
        isAuthenticated: false,
        office: undefined,
        authority: "user",
      });
      return navigate("/login");
    }
    if (auth.authority === "admin") {
      if (!selectedUser) return alert("使用者を選択してください。");
    }
    if (toggleDate) {
      if (!inputedDate) return alert("使用予定日を入力してください。");
    }
    if (!selectedProduct) {
      return alert("製品を選択してください。");
    }
    if (Number(inputedQuantity) < 1) {
      return alert("数量が0以下になっています。");
    }
    const newReservation: PushReservation = {
      office: selectedOffice,
      username: auth.authority === "user" ? auth.username : selectedUser,
      productname: selectedProduct,
      color: selectedColor,
      left_right: selectedLR,
      size: selectedSize,
      quantity: Number(inputedQuantity),
      reservation_date: toggleDate ? inputedDate : null,
    };
    const response = await fetch(`${baseUrl}/pushreservation`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newReservation),
    });
    const data = await response.json();
    if (data.isAuth === false) {
      alert("セッションが切れました。再度ログインしてください");
      setAuth({
        username: null,
        isAuthenticated: false,
        office: undefined,
        authority: "user",
      });
      return navigate("/login");
    }
    if (data.result) {
      setSelectedProduct("");
      setSelectedManufacture("");
      setInputedQuantity("1");
      setSelectedColor("");
      setSelectedLR("");
      setSelectedSize("");
      setToggleDate(false);
      setInputedDate("");
      alert("出庫予定を登録しました。");
      setReload(!reload);
    }
  };

  // const handlePrepared = async ( reservation_id: number) => {
  //         try {

  //             const response = await fetch(`${baseUrl}/prepared`, {
  //                 method: "POST",
  //                 credentials: "include",
  //                 headers: { "Content-Type": "application/json" },
  //                 body: JSON.stringify({ reservation_id: reservation_id })
  //             })
  //             const data = await response.json();
  //             if(data.isAuth===false){
  //             alert("セッションが切れました。再度ログインしてください");
  //             setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
  //             return navigate("/login");}
  //             if (data.result) {
  //                 setReload(!reload);
  //             }
  //         } catch (error) {
  //             console.error(error);
  //         }
  //     }

  //     const handleNotPrepared = async ( reservation_id: number) => {
  //         try {
  //             const response = await fetch(`${baseUrl}/notprepared`, {
  //                 method: "POST",
  //                 credentials: "include",
  //                 headers: { "Content-Type": "application/json" },
  //                 body: JSON.stringify({ reservation_id: reservation_id })
  //             })
  //             const data = await response.json();
  //             if(data.isAuth===false){
  //             alert("セッションが切れました。再度ログインしてください");
  //             setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
  //             return navigate("/login");}
  //             if (data.result) {
  //                 setReload(!reload);
  //             }
  //         } catch (error) {
  //             console.error(error);
  //         }
  //     }

  const handleLeave = async (
    e: React.MouseEvent<HTMLButtonElement>,
    index: number
  ) => {
    try {
      const item = schedule[index];
      const response = await fetch(`${baseUrl}/leave_reservation`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          reservation_id: item.reservation_id,
          office: item.office,
          productname: item.productname,
          color: item.color,
          left_right: item.left_right,
          size: item.size,
          quantity: item.quantity,
        }),
      });
      const data = await response.json();
      if (response.status === 403) {
        alert(data.message);
        return;
      }
      console.log(data);
      setReload(!reload);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (
    e: React.MouseEvent<HTMLButtonElement>,
    reservation_id: number
  ) => {
    try {
      const response = await fetch(`${baseUrl}/delete_reservation`, {
        method: "DELETE",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ reservation_id: reservation_id }),
      });
      const data = await response.json();
      if (data.isAuth === false) {
        alert("セッションが切れました。再度ログインしてください");
        setAuth({
          username: null,
          isAuthenticated: false,
          office: undefined,
          authority: "user",
        });
        return navigate("/login");
      }
      if (data.result) {
        setReload(!reload);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={styles.div}>
      <h2 className={styles.h2}>出庫予定</h2>
      {/* <Link to="/Reservation">
        <Button
          variant="contained"
          size="large"
          sx={{
            position: "absolute",
            top: 25,
            right: 50,
            fontSize: 16,
            "@media screen and (max-width:959px)": { top: 60, right: 10 },
          }}
        >
          カレンダーから出庫登録
        </Button>
      </Link> */}
      <div className={styles.window}>
        <h3 className={styles.h3}>出庫予定登録</h3>
        {auth.authority === "admin" ? (
          <div className={styles.selects}>
            <label htmlFor="支店" className={styles.label}>
              支店：
              <select
                id="支店"
                value={selectedOffice}
                className={styles.select}
                onChange={(e) => setSelectedOffice(e.target.value)}
              >
                <option value="函館店">函館店</option>
                <option value="札幌店">札幌店</option>
                <option value="釧路店">釧路店</option>
                <option value="室蘭店">室蘭店</option>
              </select>
            </label>
            <label htmlFor="使用者" className={styles.label}>
              使用者：
              <select
                value={selectedUser}
                id="使用者"
                onChange={(e) => setSelectedUser(e.target.value)}
              >
                {selectUser.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </label>
          </div>
        ) : null}
        <p className={styles.p}>
          在庫がないもので、次回発注時の注文でよいものは使用予定日を指定せず登録してください。
        </p>
        <div className={styles.selects}>
          <label htmlFor="toggleDate">
            <input
              type="checkbox"
              id="toggleDate"
              className={styles.check}
              checked={toggleDate}
              onChange={() => setToggleDate(!toggleDate)}
            ></input>
            使用予定日を指定する
          </label>
          {toggleDate && (
            <label htmlFor="使用予定日" className={styles.label2}>
              使用予定日：{inputedDate}
              <input
                type="date"
                id="使用予定日"
                className={styles.input}
                min={new Date().toISOString().split("T")[0]}
                value={inputedDate}
                onChange={(e) => {
                  setInputedDate(e.target.value);
                }}
              ></input>
            </label>
          )}
        </div>

        <div className={styles.selects}>
          <label htmlFor="メーカー" className={styles.label}>
            メーカー
            <select
              value={selectedManufacture}
              id="メーカー"
              onChange={handleManufacture}
              className={styles.select}
            >
              <option value="">未設定</option>
              {selectManufacture.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </label>
          <label htmlFor="製品" className={styles.label}>
            製品
            <select
              value={selectedProduct}
              id="製品"
              onChange={handleProduct}
              className={styles.select}
            >
              <option value="">未設定</option>
              {products.map((item) => (
                <option key={item.productname} value={item.productname}>
                  {item.productname}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className={styles.selects}>
          <label htmlFor="左右" className={styles.label}>
            左右
            <select
              value={selectedLR}
              id="左右"
              onChange={handleLR}
              className={styles.select}
            >
              {selectLR.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </label>
          <label htmlFor="サイズ" className={styles.label}>
            サイズ
            <select
              value={selectedSize}
              id="サイズ"
              onChange={handleSize}
              className={styles.select}
            >
              {selectSize.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </label>
          <label htmlFor="色" className={styles.label}>
            色
            <select
              value={selectedColor}
              id="色"
              onChange={handleColor}
              className={styles.select}
            >
              {selectColor.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </label>
          <label htmlFor="数量" className={styles.label}>
            数量
            <input
              id="数量"
              type="number"
              onChange={handleQuantity}
              className={styles.input}
              value={inputedQuantity}
            />
          </label>
        </div>
        <Button
          variant="contained"
          sx={{ margin: 1, alignSelf: "center", fontSize: 17 }}
          onClick={() => pushReservation()}
        >
          登録
        </Button>
      </div>
      <h3 className={styles.h3}>出庫予定一覧</h3>
      <label htmlFor="支店2" className={styles.label}>
        支店：
        <select
          id="支店2"
          value={selectedOffice2}
          className={styles.select}
          onChange={(e) => setSelectedOffice2(e.target.value)}
        >
          <option value="函館店">函館店</option>
          <option value="札幌店">札幌店</option>
          <option value="釧路店">釧路店</option>
          <option value="室蘭店">室蘭店</option>
        </select>
      </label>
      <div className={styles.scroll}>
        {schedule.length > 0 ? (
          <div className={styles.card}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.th}>使用者</th>
                  <th className={styles.th}>製品名</th>
                  <th className={styles.th}>色</th>
                  <th className={styles.th}>左右</th>
                  <th className={styles.th}>サイズ</th>
                  <th className={styles.th}>数量</th>
                  <th className={styles.th}>出庫希望日</th>
                  <th className={styles.th}>入庫状況</th>
                </tr>
              </thead>
              <tbody>
                {schedule.map((item: ReservationType, index) => (
                  <tr className={styles.tr} key={index}>
                    <td className={styles.td}>{item.username}</td>
                    <td className={styles.td}>{item.productname}</td>
                    <td className={styles.td}>{item.color}</td>
                    <td className={styles.td}>{item.left_right}</td>
                    <td className={styles.td}>{item.size}</td>
                    <td className={styles.td}>{item.quantity}</td>
                    <td className={styles.td}>
                      {item.reservation_date !== ""
                        ? `${item.reservation_date.year}年${item.reservation_date.month}月${item.reservation_date.date}日`
                        : "日付指定なし"}
                    </td>
                    <td className={styles.td}>
                      <div className={styles.button}>
                        {item.prepared === "未発注" && "未発注"}
                        {item.prepared === "発注済" &&
                          item.order_at + item.prepared}
                        {item.prepared === "入庫済" &&
                          item.receiveDate + item.prepared}
                      </div>
                    </td>
                    <td>
                      <Button
                        size="small"
                        sx={{ margin: 0 }}
                        onClick={(e) => handleLeave(e, index)}
                        variant="outlined"
                        disabled={item.prepared !== "入庫済"}
                      >
                        出庫
                      </Button>
                    </td>
                    <td>
                      {" "}
                      <Button
                        size="small"
                        sx={{ margin: 0 }}
                        variant="outlined"
                        onClick={(e) => handleDelete(e, item.reservation_id)}
                      >
                        取り消し
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className={styles.p2}>出庫予定はありません。</p>
        )}
      </div>
    </div>
  );
}
